import React from "react";
import * as actions from './Actions';
import Service from '../../service/Service';
const service = new Service();

function enterChildDetails(){
    if(global.userAry['childData'] && global.userAry['childData']['UserChildList'] && global.userAry['childData']['UserChildList'].length > 0){
        service.showAlert("Please Add Child Growth Details");
        window.location.href = '/tools/child-vaccination-growth-tracker?ref=growthtracker';
    } else {
        service.showAlert("Please Enter Child");
        window.location.href = '/my-account';
    }
}

export default function GrowthTkrSection ({growthData, eleRef}){
    console.log("child info -- ", global.userAry['childData']['UserChildList']);
    // console.log("------- ", Math.round(growthData.growthdata[2].height * 0.393700787));
    return(
        <section className="growth-section tracker">
            {global.ftk && growthData.growthdata.length > 0 ?
            <div className="vacc-block">
                {growthData.growthdata && growthData.growthdata.map((data, index) => 
                <div key={index}>
                <div className="sect-title M15_42">Growth Tracker</div>
                <div className="section-title">
                    <div className="vacc-icons">
                        <span className="vc_bgimg icon" data-icon-font="p"></span>
                        <span className="vc_frimg icon" data-icon-font="p"></span>
                    </div>
                    <div className="username">
                        <div className="username-inner">
                        <div className="xyz-name">{data.name}'s Growth Tracker</div>
                        <div className="vacc-month">Age - {data.age} Months</div>
                        </div>
                    </div>
                </div>
                <div className="updatedOn-block">
                    <span className="left" data-icon-font="%"></span>
                    <span className="left updatedOn-text">Updated on {data.growthdate}</span>
                    <a href="/tools/child-vaccination-growth-tracker?ref=growthtracker" className="right add-growth-btn">Add Growth Details</a>
                </div>
                <div className="infotable">
                    <table border="1">
                        <thead>
                            <tr>
                                <th className="M13_42">Meas.</th>
                                <th className="M13_42">Child's Info</th>
                                <th className="M13_42">Ideal Range</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="M12_9e">Weight</td>
                                <td className="M12_9e">{data.weight} kg</td>
                                <td className="M12_9e">{data.minwt} - {data.maxwt} kg</td>
                            </tr>
                            <tr>
                                <td className="M12_9e">Height</td>
                                <td className="M12_9e">
                                {data.htut == 1 ?
                                `${(data.height * 0.393700787).toFixed(2)} in`
                                : `${data.height} cm`
                                }
                                </td>
                                <td className="M12_9e">
                                {data.htut == 1 ?
                                `${(data.minht*0.393700787).toFixed(2)} - ${(data.maxht*0.393700787).toFixed(2)} in`
                                : `${data.minht} - ${data.maxht} cm`
                                }
                                </td>
                            </tr>
                            <tr>
                                <td className="M12_9e">Head Circ.</td>
                                <td className="M12_9e">
                                {data.hcut == 1 ?
                                `${(data.circumference*0.393700787).toFixed(2)} in`
                                : `${data.circumference} cm`
                                }
                                </td>
                                <td className="M12_9e">
                                {data.hcut == 1 ?
                                `${(data.minhc*0.393700787).toFixed(2)} - ${(data.maxhc*0.393700787).toFixed(2)} in`
                                : `${data.minhc} - ${data.maxhc} cm`
                                }
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                </div>
                )}
                {growthData.search_cnt > growthData.growthdata.length &&
                <div className="moreResults dev_v_all" title="Growth Tracker" onClick={()=>eleRef.getMoreSearchData(growthData.type)}>SEE MORE RESULTS</div>
                }
            </div>
            : 
            <div>
            <div className="section-title">Growth Tracker</div>
            <div className="non_loggedin" id="non_loggedin">
                <div className="vacc-img left">
                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/growth_tracker_image_rounded.jpg" alt="Baby Growth Tracker" title="Baby Growth Tracker" />
                </div>
                <ul className="vacc-features left">
                    <li>
                        <span className="vc_gr_icons left" data-icon-font="W"></span>
                        <span  className="R11_42 left feature">Gender age/gender wise growth chart</span>
                    </li>
                    <li>
                        <span className="vc_gr_icons left" data-icon-font="B"></span>
                        <span  className="R11_42 left feature">Compare with WHO standards</span>
                    </li>
                    <li>
                        <span className="vc_gr_icons left" data-icon-font="5"></span>
                        <span  className="R11_42 left feature">Get reminders at regular intervals</span>
                    </li>
                    <li>
                        <span className="vc_gr_icons left" data-icon-font="."></span>
                        <span  className="R11_42 left feature">Maintain Digital Records</span>
                    </li>
                </ul>
            </div>
            {global.ftk && growthData.growthdata.length <= 0 ? 
                <div className="moreResults dev_v_all" title="Growth Tracker" onClick={()=>enterChildDetails()}>SEE MORE RESULTS</div>
                :
                <div className="moreResults dev_v_all" title="Growth Tracker" onClick={()=>actions.nonLoggedin()}>SEE MORE RESULTS</div>
            }
            
            </div>
            }
        </section>
    );
}
